<template>
  <svgicon :icon="name"></svgicon>
</template>
<script>
export default {
  name: "Icon",
  props: {
    name: { type: String, required: true }
  }
};
</script>
